<div class="sidebar-steps d-flex justify-content-center">
    <ng-container *ngFor="let stepNum of steps" class="step-oval">
        <div class="step-oval" [ngClass]="{'step-disabled': step !== stepNum}">
            <span class="step-oval-text">{{stepNum}}</span>
        </div>
    </ng-container>
</div>
